import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import theme from './theme';
import Index from './pages';
import Checkout from './components/organism/checkout/checkout';
import ProductDetail from './components/organism/productDetail/productDetail';
import OrderSuccess from './components/molecule/ordersuccess/ordersuccess';
import SignIn from './components/organism/signin/signin';
import Admin from './components/organism/admin/admin';
import { AuthProvider } from './context/authContext';
import ProtectedRoute from './context/privateRoutes';
import Header from './components/molecule/header/header';
import PageTransition from './components/atome/motion/pageTransition';

const queryClient = new QueryClient();

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <AuthProvider>
            <Header />
            <PageTransition>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/order-success" element={<OrderSuccess />} />

                {/* Staff only. Not linked from the storefront — typed in directly. */}
                <Route path="/signin" element={<SignIn />} />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute requireAdmin>
                      <Admin />
                    </ProtectedRoute>
                  }
                />

                <Route path="*" element={<Index />} />
              </Routes>
            </PageTransition>
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;
